/** Collapse accidental nested `<mention>` wrappers from older clients. */
export function normalizeMentionTags(text: string): string {
  let result = text;
  let prev = "";
  while (prev !== result) {
    prev = result;
    result = result.replace(/<mention(?:\s[^>]*)?>\s*<mention(?:\s[^>]*)?>/gi, "<mention>");
    result = result.replace(/<\/mention>\s*<\/mention>/gi, "</mention>");
  }
  return result;
}

/** Unwrap legacy `<mention>@Name</mention>` tags (no id) to plain `@Name` for display. */
export function unwrapIdlessMentionTags(text: string): string {
  return text.replace(/<mention(?!\s+id=")[^>]*>@?([^<]*)<\/mention>/gi, "@$1");
}

/** Normalize mention markup before persistence. Plain typed `@Name` is left as-is (not a mention). */
export function wrapMentionsInBody(text: string): string {
  return normalizeMentionTags(text);
}
